module.exports = __webpack_public_path__ + "static/materials-4a1d4ae19d99dd4f8ecdaf60d0844761.png";